var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"left-border",class:_vm.isMobile ? 'clear-dropdown' : ''},[(_vm.currency)?[_vm._v("("+_vm._s(_vm.$t('app.currency'))+": "+_vm._s(_vm.currency)+")")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }